import $http from '@vue-util/http';
import hostlinkOrDevMode from '~/utils/hostlinkOrDevMode';
import type { Review } from '~~/shared/globalTypes/reviews';

type ReviewsResponse = {
  data: {
    review:
      | {
          totalResults: number;
          reviews: Review[];
        }
      | {
          chips: {
            totalResult: number;
            reviews: Review[];
          };
        };
  };
};

const getBaseUrl = (hostlink: string, productId: string) => `${hostlinkOrDevMode(hostlink)}/xapi/digital/v1/product/${productId}/reviews`;

export function newReviewsReqService({ productId, params }: { productId: string; params: Record<string, unknown> }): Promise<ReviewsResponse> {
  return $fetch(`/api/pdp-ui/reviews/${productId}`, {
    query: params,
  });
}

// Todo - delete this once ks no longer needed for perf enhancement
export function reviewsReqService({ hostlink, productId, params }: { hostlink: string; productId: string; params: Record<string, unknown> }) {
  return $http.get(getBaseUrl(hostlink, productId), { params });
}
